// extracted by mini-css-extract-plugin
export default {"PrintableLink":"PrintableLink-styles__PrintableLink__utDN5"};